var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "webhook-data-item" },
    [
      _c(
        "div",
        { staticClass: "btnGroup" },
        _vm._l(["static", "dynamic"], function (item) {
          return _c(
            "SupsisButton",
            {
              key: item,
              attrs: {
                classNames:
                  _vm.selectType === item
                    ? "btnGroupItem selected"
                    : "btnGroupItem ",
                primary: _vm.selectType === item,
                ghost: _vm.selectType !== item,
                small: "",
              },
              on: {
                click: function ($event) {
                  _vm.selectType = item
                },
              },
            },
            [_vm._v("\n            " + _vm._s(item) + "\n        ")]
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.selectType === "dynamic"
        ? _c("TiptapEditor", {
            attrs: {
              placeholder: "Tag",
              "show-attributes": true,
              "max-character-count": 500,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.value,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "value", $$v)
              },
              expression: "clone.value",
            },
          })
        : _c("TagPicker", {
            model: {
              value: _vm.clone.value,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "value", $$v)
              },
              expression: "clone.value",
            },
          }),
      _vm._v(" "),
      _vm.isDeleteButtonVisible
        ? _c(
            "SupsisButton",
            { attrs: { small: "", danger: "" }, on: { click: _vm.deleteItem } },
            [_c("i", { staticClass: "material-icons" }, [_vm._v("delete")])]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }